/**
 * "Simulated" — beside every simulated site's name, wherever a site is named (0117).
 *
 * A Playground site behaves like Lumen on screen — alarms, work orders, the dashboards — and that
 * is the point of it, so nothing about its cards looks different. This pill is what does: in the
 * header scope, the Sites list, the status strip and the Overview, so nobody mistakes a generated
 * grid failure for a real one. A word, never a colour alone. Docs/08-views/PLAYGROUND.md.
 */
import type { ReactNode } from 'react';
import { ToneChip } from './ToneChip';
import { buildingWords } from './simulation-words';

export const SIMULATED_TITLE =
  'A Playground site: its readings are generated for demonstration. Nothing here leaves the platform: no email is sent and no report can be sealed.';

export function SimulatedPill({ simulated }: { simulated: boolean | undefined }): ReactNode {
  if (!simulated) return null;
  return <ToneChip tone="info" label="Simulated" title={SIMULATED_TITLE} />;
}


export function SimulationBuilding({
  sim,
}: {
  sim: { state: 'priming' | 'building'; progress: number; secondsLeft: number } | null | undefined;
}): ReactNode {
  if (!sim) return null;
  return <span className="shrink-0 text-[12px] font-medium text-[var(--muted-fg)]">{buildingWords(sim)}</span>;
}
